import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IncludeInfo } from 'src/app/domainObjects/includeInfo';

@Component({
    selector: 'app-include-builder',
    templateUrl: './include-builder.component.html',
    styleUrls: ['./include-builder.component.css'],
    standalone: false
})
export class IncludeBuilderComponent implements OnInit {
  
  includeItems: IncludeInfo[] = [];
  fields: string[];
  selectedIncludeInfo?: IncludeInfo;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<IncludeBuilderComponent>) {
      this.fields = data.fields;
      this.fields.sort( (a, b) => a < b ? -1 : 0);
      this.includeItems = data.includeItems;

      // remove fields which are in sortItems to avoid dups
      this.includeItems.forEach(x => {
        const index = this.fields.findIndex(f => f === x.includeField);
        if (index >= 0) {
          this.fields.splice(index, 1);
        }
      });
    }

  ngOnInit(): void {
  }
  
  includeInfoSelected(event: any): void {
    this.selectedIncludeInfo = event.option.value;
  }

  removeItem(item: IncludeInfo): void {
    const index = this.includeItems.indexOf(item);
    if (index >= 0) {
      this.includeItems.splice(index, 1);
    }

    this.fields.push(item.includeField);
    this.fields.sort( (a, b) => a < b ? -1 : 0);
    this.selectedIncludeInfo = null;
  }

  saveChanges(): void {
    this.dialogRef.close({includeItems: this.includeItems });
  }

  newItem(option: any): void {
    if (!option || option.length === 0 ) {
       return;
    }

    const info = new IncludeInfo(option);
    info.includeField = option;

    const index = this.fields.indexOf(option);
    if (index >= 0) {
      this.fields.splice(index, 1);
    }
    
    this.includeItems.push( info );
  }
}
